var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"modern-card",attrs:{"width":"100%","elevation":"0"}},[_c('apexchart',{attrs:{"height":"400px","type":"pie","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }